// import config from '@/config'
import Vue from 'vue'
const JSON = require('circular-json')
export default {
  getLocalStorage(key) {
    var value = localStorage.getItem(key)
    return value ? JSON.parse(value) : false
  },
  setLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  removeLocalStorage(key) { localStorage.removeItem(key) },
  setSessionStorage(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  getSessionStorage(key) {
    var value = sessionStorage.getItem(key)
    return value ? JSON.parse(value) : false
  },
  getParam(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    if (window.location.hash.indexOf('?') < 0) {
      return null
    }
    const r = window.location.hash.split('?')[1].match(reg)
    if (r != null) {
      if (decodeURIComponent(r[2]) == "''") {
        return ''
      }
      return decodeURIComponent(r[2])
    }
    return null
  },
  getweiShaoParam(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    if (window.location.search.indexOf('?') < 0) {
      return null
    }
    const r = window.location.search.split('?')[1].match(reg)
    if (r != null) {
      if (decodeURIComponent(r[2]) == "''") {
        return ''
      }
      return decodeURIComponent(r[2])
    }
    return null
  },
  removeSessionStorage(key) { sessionStorage.removeItem(key) },
  getCookie(name) {
    var arr; var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    if (arr = document.cookie.match(reg)) { return unescape(arr[2]) } else { return false }
  },
  setQueryConfig(queryConfig) {
    var _str = ''
    for (var o in queryConfig) {
      _str += o + '=' + queryConfig[o] + '&'
    }
    var _str = _str.substring(0, _str.length - 1)
    return _str
  },
  checkBrowser() {
    var ua = navigator.userAgent.toLocaleLowerCase()
    var browserType = null
    if (ua.match(/msie/) != null || ua.match(/trident/) != null) {
      browserType = 'IE'
      browserVersion = ua.match(/msie ([\d.]+)/) != null ? ua.match(/msie ([\d.]+)/)[1] : ua.match(/rv:([\d.]+)/)[1]
    } else if (ua.match(/firefox/) != null) {
      browserType = '火狐'
    } else if (ua.match(/ubrowser/) != null) {
      browserType = 'UC'
    } else if (ua.match(/opera/) != null) {
      browserType = '欧朋'
    } else if (ua.match(/bidubrowser/) != null) {
      browserType = '百度'
    } else if (ua.match(/metasr/) != null) {
      browserType = '搜狗'
    } else if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
      browserType = 'QQ'
    } else if (ua.match(/maxthon/) != null) {
      browserType = '遨游'
    } else if (ua.match(/chrome/) != null) {
      var is360 = _mime('type', 'application/vnd.chromium.remoting-viewer')
      function _mime(option, value) {
        var mimeTypes = navigator.mimeTypes
        for (var mt in mimeTypes) {
          if (mimeTypes[mt][option] == value) {
            return true
          }
        }
        return false
      }
      if (is360) {
        browserType = '360'
      } else {
        browserType = '谷歌'
      }
    } else if (ua.match(/safari/) != null) {
      browserType = 'Safari'
    }
    return browserType
  },

  exportXls(query, url = '/match-boot/admin/export/excel/projectScoreList') {
    for (var o in query) {
      query[o] = encodeURIComponent(query[o])
    }
    var { token } = this.getLocalStorage('userInfo')
    query = { ...query, token }
    const name = this.checkBrowser()
    if (name === '360') {
      window.open(Vue.prototype.$config.file +
        url + '?' +
        this.setQueryConfig(query))
    } else {
      window.location = Vue.prototype.$config.file +
        url + '?' +
        this.setQueryConfig(query)
    }
  },
  DragDiv() {
    // 获取拖拽内容头部
    const dialogHeaderEl = document.querySelector('.dialog_header')
    // 获取拖拽内容整体 这个rrc-dialog是我自己封装的组件 如果使用element的组件应写成.el-dialog
    const dragDom = document.querySelector('.chat_dialog')
    dialogHeaderEl.style.cursor = 'move'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);

    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    // 鼠标按下事件
    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离 (鼠标点击位置距离可视窗口的距离)
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      // 获取到的值带px 正则匹配替换
      let styL, styT

      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }

      // 鼠标拖拽事件
      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离 （开始拖拽至结束拖拽的距离）
        const l = e.clientX - disX
        const t = e.clientY - disY

        let finallyL = l + styL
        let finallyT = t + styT

        // 边界值判定 注意clientWidth scrollWidth区别 要减去之前的top left值
        // dragDom.offsetParent表示弹窗阴影部分
        if (finallyL < 0) {
          finallyL = 0
        } else if (finallyL > dragDom.parentElement.clientWidth - dragDom.clientWidth - dragDom.parentElement.offsetLeft) {
          finallyL = dragDom.parentElement.clientWidth - dragDom.clientWidth - dragDom.parentElement.offsetLeft
        }

        if (finallyT < 0) {
          finallyT = 0
        } else if (finallyT > dragDom.parentElement.clientHeight - dragDom.clientHeight - dragDom.parentElement.offsetLeft) {
          (
            finallyT = dragDom.parentElement.clientHeight - dragDom.clientHeight - dragDom.parentElement.offsetLeft
          )
        }

        // 移动当前元素
        dragDom.style.left = `${finallyL}px`
        dragDom.style.top = `${finallyT}px`
        dragDom.style.right = 'unset'
        dragDom.style.bottom = 'unset'

        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }

      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  },
  // yyyy-dd-tt转成时间戳
  changetime(val) {
    const d = new Date(val)
    const t = d.getTime(d)
    return t
  }
}



// WEBPACK FOOTER //
// ./src/axios/tool.js